import { isArray } from 'lodash/fp';
import { useRouter } from 'next/router';

import { JourneyProductType } from '../../../build-your-cover/types';
import { URL_SLUG_TO_JOURNEY_TYPE } from '../../../build-your-cover/constants';

export const CHOOSE_YOUR_COVER_TYPE_PARAM = 'chooseYourCoverType';

const useChooseYourCoverJourneyType = () => {
  const router = useRouter();
  const param = router.query[CHOOSE_YOUR_COVER_TYPE_PARAM];
  if (!param || isArray(param) || !URL_SLUG_TO_JOURNEY_TYPE[param]) return undefined;
  return param as JourneyProductType;
};

export default useChooseYourCoverJourneyType;
